export function syncTry<T>(
  handler: ErrorHandler,
  perform: CallableFunction,
  ...args: unknown[]
): T | void {
  try {
    return perform(...args);
  } catch (error) {
    return handler(error);
  }
}
